import { useTranslation } from "react-i18next";

function DeleteConfirmModal({
  closeModal,
  handleDelete,
  loading,
  msg,
}: {
  closeModal: () => void;
  handleDelete: () => void;
  loading?: boolean;
  msg: string;
}) {
  const { t } = useTranslation();
  const saveText = "Delete";
  const cancleText = "Close";
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-5 rounded-md shadow-lg flex flex-col justify-between items-end w-[90%] sm:w-[500px] h-[auto] max-h-[80vh]">
        <div className="flex flex-col items-start justify-start gap-5 w-full">
          <h2 className="text-lg font-semibold text-red-600">
            {t("Confirm Action")}
          </h2>
          <p className="mt-2">{t(msg)}</p>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded"
            onClick={handleDelete}
          >
            {loading ? `${t("Deleting")}...` : t(saveText)}
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded"
            onClick={closeModal}
          >
            {t(cancleText)}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
